export function archiveSelect() {
  const selects = document.querySelectorAll(".js-archive-select");
  if (!selects.length) return;

  selects.forEach((select) => {
    select.addEventListener("change", () => {
      window.location.href = select.value;
    });
  });
}
